const fr: Record<string, string> = {
  'journal.tabDay': 'Jour',
  'journal.tabByLabel': 'Par étiquette',
  'journal.emptyDay': 'Aucune entrée pour ce jour. Cliquez sur + pour commencer.',
  'journal.addBlock': 'Ajouter un bloc',
  'journal.editBlock': 'Modifier',
  'journal.deleteBlock': 'Supprimer',
  'journal.save': 'Enregistrer',
  'journal.cancel': 'Annuler',
  'journal.moveUp': 'Monter',
  'journal.moveDown': 'Descendre',
  'journal.labels': 'Étiquettes',
  'journal.noLabel': 'Aucune étiquette sélectionnée',
  'journal.selectLabel': 'Filtrer par étiquette...',
  'journal.all': 'Toutes',
  'journal.createLabel': 'Créer une étiquette',
  'journal.labelNamePlaceholder': "Nom de l'étiquette",
  'journal.create': 'Créer',
  'journal.journalEntries': 'Entrées de journal',
  'journal.blockCount': '{{count}} bloc',
  'journal.blockCount_other': '{{count}} blocs',
  'journal.today': 'Aujourd\'hui',
};

export default fr;
